export function useTabManagement({
  whiteboards, setWhiteboards,
  setDocContainers, setDocBanners,
  setHomeworkContainers, setHomeworkBanners, setHomeworkDataCache,
  currentTab, setCurrentTab, prevTab,
}) {
  const onDeleteTab = (index) => {
    const newWhiteboards = whiteboards.filter((_, i) => i !== index - 1);
    const deletedWhiteboard = whiteboards[index - 1];

    // Очищаем localStorage для удаленного whiteboard'а/doc'а
    if (deletedWhiteboard) {
      localStorage.removeItem(`whiteboard_${deletedWhiteboard.id}`);
    }

    // Удаляем контейнеры doc таба если удаляем doc
    if (deletedWhiteboard?.type === 'doc') {
      setDocContainers(prev => {
        const newDocContainers = { ...prev };
        delete newDocContainers[deletedWhiteboard.id];
        return newDocContainers;
      });
      // Также удаляем баннер doc'а
      setDocBanners(prev => {
        const newDocBanners = { ...prev };
        delete newDocBanners[deletedWhiteboard.id];
        return newDocBanners;
      });
    }

    // Удаляем контейнеры homework таба если удаляем homework
    if (deletedWhiteboard?.type === 'homework') {
      setHomeworkContainers(prev => {
        const newHomeworkContainers = { ...prev };
        delete newHomeworkContainers[deletedWhiteboard.id];
        return newHomeworkContainers;
      });
      // Удаляем баннер homework
      setHomeworkBanners(prev => {
        const newHomeworkBanners = { ...prev };
        delete newHomeworkBanners[deletedWhiteboard.id];
        return newHomeworkBanners;
      });
      // Очищаем кеш для удаленного homework
      setHomeworkDataCache(prev => {
        const newCache = { ...prev };
        delete newCache[deletedWhiteboard.id];
        return newCache;
      });
    }

    setWhiteboards(newWhiteboards);
    if (currentTab === index) {
      setCurrentTab(0);
    } else if (currentTab > index) {
      setCurrentTab(currentTab - 1);
    }
  };

  const onReorderTabs = (fromIndex, toIndex) => {
    const newWhiteboards = [...whiteboards];
    const [movedTab] = newWhiteboards.splice(fromIndex - 1, 1);
    newWhiteboards.splice(toIndex - 1, 0, movedTab);

    setWhiteboards(newWhiteboards);

    // Обновляем currentTab если нужно
    if (currentTab === fromIndex) {
      setCurrentTab(toIndex);
    } else if (currentTab > fromIndex && currentTab <= toIndex) {
      setCurrentTab(currentTab - 1);
    } else if (currentTab < fromIndex && currentTab >= toIndex) {
      setCurrentTab(currentTab + 1);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const getSlideDirection = () => {
    if (currentTab > prevTab) return 'slide-left';
    if (currentTab < prevTab) return 'slide-right';
    return '';
  };

  // ОТКЛЮЧЕНО: drag and drop функции контейнеров
  // const handleDragStart = (e, id) => {
  //   setDraggedContainer(id);
  //   e.dataTransfer.effectAllowed = 'move';
  // };

  // const handleDragOver = (e) => {
  //   e.preventDefault();
  //   e.dataTransfer.dropEffect = 'move';
  // };

  // const handleDrop = (e, targetId) => {
  //   e.preventDefault();
  //   if (draggedContainer === targetId) return;

  //   setContainers(prev => {
  //     const newContainers = [...prev];
  //     const draggedIndex = newContainers.findIndex(c => c.id === draggedContainer);
  //     const targetIndex = newContainers.findIndex(c => c.id === targetId);

  //     const [draggedItem] = newContainers.splice(draggedIndex, 1);
  //     newContainers.splice(targetIndex, 0, draggedItem);

  //     return newContainers;
  //   });
  // };

  // const handleDragEnd = () => {
  //   setDraggedContainer(null);
  // };

  return { onDeleteTab, onReorderTabs };
}
